import { message as staticMessage } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';

/**
 * ConfigProvider 테마가 적용된 message 로 연결하는 얇은 유틸.
 *
 * antd 의 정적 `message.error()` 등은 React 트리 밖(document.body)에 자체 루트를 만들어
 * ConfigProvider 테마를 못 받는다 — 다크 모드에서 흰 토스트가 뜨던 원인(2026-10-19 감사
 * "화면 · 다크"). `<App>` 안에서 만든 인스턴스를 여기 등록해 두고 호출부는 이 모듈을 쓴다.
 *
 * 인스턴스가 아직 없으면(마운트 전, 또는 <App> 없이 렌더하는 테스트) 기존 정적 API 로
 * 폴백한다 — 동작은 예전과 같고 테마만 못 받는다.
 */
let instance: MessageInstance | null = null;

/** `<App>` 이 마운트되면 그 안의 message 인스턴스를 등록한다. */
export const setAppMessageInstance = (next: MessageInstance | null): void => {
  instance = next;
};

const current = (): MessageInstance => instance ?? (staticMessage as unknown as MessageInstance);

export const appMessage: Pick<
  MessageInstance,
  'info' | 'success' | 'error' | 'warning' | 'loading' | 'open'
> = {
  info: (...args) => current().info(...args),
  success: (...args) => current().success(...args),
  error: (...args) => current().error(...args),
  warning: (...args) => current().warning(...args),
  loading: (...args) => current().loading(...args),
  open: (args) => current().open(args),
};
